class LogoSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector(".section-logo-slider-slider");
    if (!swiperEl) return;

    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const mobileAutoScroll =
      this.dataset.mobileAutoScroll === "true";

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",

      loop: isMobile && mobileAutoScroll,

      speed: isMobile && mobileAutoScroll ? 6000 : 500,

      autoplay:
        isMobile && mobileAutoScroll
          ? {
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }
          : false,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },

      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get("logo-slider")) {
  customElements.define("logo-slider", LogoSlider);
}